import { styled } from '@mui/system'
import { themeSpacing } from '../../../helpers'
import { Theme } from '@mui/material'

export const GridContainer = styled('div')<{
  theme: Theme
  min: number
  space: number
  isWide: boolean
}>`
  height: 100%;
  display: grid;
  gap: ${({ space }) => themeSpacing(space)};
  grid-auto-rows: minmax(0, 1fr);
  align-content: stretch;
  align-items: stretch;
  grid-template-columns: ${({ min, isWide }) =>
    isWide ? `repeat(auto-fit, minmax(${min}px, 1fr))` : '100%'};
`
